import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import voca from 'voca';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MuiButton from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import MuiGrid from '@material-ui/core/Grid';
import useStores from '../../../utils/useStores';
import Wrap from '../../depi/sections/Wrap';

const Sticker1 = '/images/Logo_Fachstudio.svg';
const Sticker2 = '/images/Logo_Pelletfachbetrieb.svg';

const ExpertsSection = () => {
  const { dataStore } = useStores();
  const page = dataStore.pages.asList.find(
    p => p.uuid === '27168863-61ab-411b-8940-6a9aa6ba62df',
  );

  if (!page) return null;

  const abstract = voca.prune(page.data.abstract, 400, ' ...');
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <Wrap bgcolor="primary.light">
      <Typography
        variant="h2"
        color="secondary"
        data-underline
        data-underline-white
      >
        {page.title}
      </Typography>
      <MuiGrid container spacing={2}>
        <MuiGrid item xs={12} sm={6}>
          <Typography color="secondary" variant="h6">
            {abstract}
          </Typography>
        </MuiGrid>
        <MuiGrid item xs={12} sm={6}>
          <Box display="flex">
            <Box mr={2}>
              <img src={Sticker1} />
            </Box>
            <Box ml={2}>
              <img src={Sticker2} />
            </Box>
          </Box>
        </MuiGrid>
      </MuiGrid>
      <Box display="flex" justifyContent="center" mt={4}>
        <Box mr={2}>
          <Link
            href={`${linkContext}[...pageId]`}
            as={`${linkContext}informationen-fuer-fachleute`}
            passHref
          >
            <MuiButton variant="outlined" color="secondary" size="large">
              Mehr für Fachleute
            </MuiButton>
          </Link>
        </Box>
        <Box ml={2}>
          <MuiButton
            href="https://www.grüne-wärme.info"
            variant="outlined"
            color="secondary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Zum E-Learning
          </MuiButton>
        </Box>
      </Box>
    </Wrap>
  );
};

export default observer(ExpertsSection);
